import { gql } from '@apollo/client'

export const DOOR_LIST = gql`
query registeredDoors{
    registeredDoors {
      edges {
        node {
          objectId
          doorInfo
          ipAddress
        }
      }
    }
  }
`